import { Icon, styled } from '@innowise-group/mui-kit';

export const FileItem = styled.div<{ disabled: boolean; hasActions: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'normal' : 'pointer')};
  border-radius: 0 0.5rem 0.5rem 0;
  flex: 1;
  width: 100%;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  ${({ theme }) => theme.fonts.primary[60]}
  color: ${({ theme }) => theme.palette.info.default};
  background-color: ${({ theme }) => theme.palette.info.backgroundSecondary};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
  position: relative;
  padding: 0.875rem;
  padding-right: ${({ hasActions }) => (hasActions ? '3rem' : '0.875rem')};
  box-sizing: border-box;
  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};

  &::after {
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%) scaleX(0.6) translateX(-40%);
    content: '';
    height: 100%;
    width: 0.5rem;
    background-color: ${({ theme }) => theme.palette.info.default};
    border-radius: 0px 3rem 3rem 0px;
  }
`;

export const FileTitle = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  width: 100%;

  & > svg {
    flex-shrink: 0;
  }
`;

export const FileInfo = styled.div`
  min-width: 0;
`;

export const FileName = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const FileDate = styled.div`
  ${({ theme }) => theme.fonts.primary[20]}
  color: ${({ theme }) => theme.palette.general.darkGrey[60]};
`;

export const FileAuthor = styled(FileDate)``;

export const IconsContainer = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const LockIcon = styled(Icon)`
  position: relative;
  left: 3px;

  & > svg,
  &:hover > svg {
    flex-shrink: 0;
    fill: ${({ theme }) => theme.palette.info.default};
  }
`;

export const DeleteIcon = styled(LockIcon)`
  left: 0;

  & > svg {
    fill: ${({ theme }) => theme.palette.state.error.default};
    transform: rotate(45deg);
    transition: 0.2s;
  }

  &:hover svg {
    fill: ${({ theme }) => theme.palette.state.error.hover};
  }
`;
